
export default {
  data () {
    return {
    }
  },
  mounted: function () {
    let token = this.$route.query['X-Authorization']
    if (token) {
      localStorage.setItem('token', token)
    }
    let redirectTo = this.$route.query.redirectTo
    if (redirectTo) {
      window.location.href = '/#' + redirectTo
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/router-center.js